import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import TextField from '@mui/material/TextField';
import { useCallback, useId, useState } from 'react';
import { createUpdateReverifyEmailOutbound } from '../../api/outbound/reverifyOutbounds';
import { FormControlContainer } from '../../components/formControlContainer';
import { FullScreenModalContainer } from '../../components/fullScreenModalContainer';
import { useSocketSend } from '../../context/webSocket/webSocketContext';
import { setIsReverifyActionPending, setReverifyPage } from '../../redux/actions/reverifyActions';
import { addToast, thunkCloseToast } from '../../redux/actions/toastsActions';
import { useAppDispatch, useAppSelector } from '../../redux/store';
import { CHANGE_EMAIL_TOAST_KEY } from '../../types/toastTypes';
import { REVERIFY_PAGE_BUTTONS_CONTAINER_CSS, REVERIFY_PAGE_EMAIL_CSS } from './reverifyPageConstants';
export const ReverifyUpdateEmailFormPage = () => {
    const dispatch = useAppDispatch();
    const socketSend = useSocketSend();
    const currentEmail = useAppSelector((state) => state.reverify.currentEmail);
    const isActionPending = useAppSelector((state) => state.reverify.isActionPending);
    const textFieldId = useId();
    const [newEmail, setNewEmail] = useState('');
    const onChangeNewEmail = (event) => {
        setNewEmail(event.target.value);
    };
    const onClickCancel = useCallback(() => {
        dispatch(thunkCloseToast(CHANGE_EMAIL_TOAST_KEY));
        dispatch(setReverifyPage('ask'));
    }, [dispatch]);
    const onClickUpdate = useCallback(() => {
        dispatch(thunkCloseToast(CHANGE_EMAIL_TOAST_KEY));
        if (!newEmail) {
            dispatch(addToast({
                type: 'change-email-error',
                key: CHANGE_EMAIL_TOAST_KEY,
                message: 'Enter a new email.'
            }));
            return;
        }
        dispatch(setIsReverifyActionPending(true));
        socketSend(createUpdateReverifyEmailOutbound(newEmail));
    }, [dispatch, newEmail, socketSend]);
    return (_jsxs(FullScreenModalContainer, { title: 'Verify Email Account', children: [_jsx("div", { children: "Update your email address where you can verify your account." }), _jsxs("div", { children: ["Current Email: ", _jsx("span", { css: REVERIFY_PAGE_EMAIL_CSS, children: currentEmail })] }), _jsx("div", { css: css `
          min-width: 400px;
          max-width: 100%;
        `, children: _jsx(FormControlContainer, { children: _jsx(TextField, { id: textFieldId, variant: 'filled', fullWidth: true, label: 'New Email', value: newEmail, onChange: onChangeNewEmail }) }) }), _jsxs("div", { css: REVERIFY_PAGE_BUTTONS_CONTAINER_CSS, children: [_jsx(Button, { onClick: onClickUpdate, variant: 'contained', disabled: isActionPending, endIcon: isActionPending ? _jsx(CircularProgress, { size: 20, color: 'inherit' }) : undefined, children: "Update Email" }), _jsx(Button, { onClick: onClickCancel, variant: 'outlined', disabled: isActionPending, children: "Cancel" })] })] }));
};
